export default __webpack_public_path__ + "static/media/Orlando Magic.0cf57df8.png";